export default __webpack_public_path__ + "10ded7920110f61e7b16d22db2aeae4a.png";